module.exports = __webpack_public_path__ + "img/zoom.e2382883.svg";